import { render, staticRenderFns } from "./generic-new.vue?vue&type=template&id=7766b589&scoped=true&"
import script from "./generic-new.vue?vue&type=script&lang=js&"
export * from "./generic-new.vue?vue&type=script&lang=js&"
import style0 from "./generic-new.vue?vue&type=style&index=0&id=7766b589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7766b589",
  null
  
)

export default component.exports